var Marionette = require('backbone.marionette');
var Document = require('../../models/document-model');
var DocumentType = require('../../models/document-type-model');
var CommonUtils = require('../../utils/common-utils.js');
var EntitiesSelectView = require('../entities/entities-select');
var DocumentTypesCollection = require('../../collections/document-types-collection');
var Radio = require('backbone.radio');

var notificationsChannel = Radio.channel('notifications');


var DocumentSignData = Marionette.View.extend({
    template: require('../../templates/documents/document-sign-data.html'),

    model: new Document(),

    regions:{
        docTypes: '#doc-types-list'
    },

    childViewEvents:{
        'entity:selected': 'entitySelected'
    },

    ui: {
        settings: '#settings',
        signsLimit: '#signs-limit',
        signX: '#sign-x',
        signY: '#sign-y',
        signWidth: '#sign-width',
        pagesToSign: '#pages-to-sign',
        signAllPages: '#sign-all-pages',
        cancelBtn: '#cancel',
        saveBtn: '#save',
        previewBtn: '#preview'
    },

    events: {
        'click @ui.cancelBtn': 'cancel',
        'click @ui.saveBtn': 'saveDocumentSignData',
        'click @ui.previewBtn': 'previewDocument',
        'click @ui.signAllPages': 'disablePagesToSignElement',
        'change input': 'onInputChange',
        'keyup input': 'onInputChange',
        'keypress input[type=number]': 'onKeyPress'
    },

    signSettings: {},

    templateContext: function () {
        var that = this;
        return {
            canEdit: function() { return that.canEdit(); }
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'onRender', 'cancel', 'disablePagesToSignElement', 'saveDocumentSignData', 'onInputChange', 'previewDocument',
            'buildSignSettingsObject', 'onKeyPress', 'findModel', 'fillForm');
        this.model = options.model;
        this.canEdit = options.canEdit;
        this.utils = new CommonUtils();
        this.docTypesCollection = new DocumentTypesCollection([], {params:
            [{key: 'sortby', value: 'name'}, {key: 'sortdir', value: 'ASC'}]
        });
        this.documentTypeModelDefault = new DocumentType();
    },

    onRender: function () {
        var that = this;
        if (that.model.get('object').signSettings.signAllPages)
            that.ui.pagesToSign.attr('disabled', 'disabled');

        that.docTypesCollection.fetch({success: function() {
            that.documentTypeSelectView = new EntitiesSelectView({
                entityType: 'documentType',
                customPlaceholder: 'Select a document type',
                collectionValues: that.docTypesCollection
            });
            that.showChildView('docTypes', that.documentTypeSelectView);
        }});
    },

    onInputChange: function() {
        this.ui.saveBtn.removeAttr("disabled");
    },

    cancel: function () {
    },

    buildSignSettingsObject: function() {
        this.signSettings.signsLimit = this.ui.signsLimit.val();
        this.signSettings.signX = this.ui.signX.val();
        this.signSettings.signY = this.ui.signY.val();
        this.signSettings.signWidth = this.ui.signWidth.val();
        if (this.signSettings.signAllPages)
            this.signSettings.pagesToSign = '';
        else
            this.signSettings.pagesToSign = this.ui.pagesToSign.val();

        return this.signSettings;
    },

    previewDocument: function() {
        var signSettingsflat = JSON.stringify(this.buildSignSettingsObject());
        window.open('/api/document/preview/' + this.model.get('id') + '?settings=' + signSettingsflat, '_blank');
    },

    saveDocumentSignData: function () {
        var that =this;
        var object = that.model.get('object');
        object.signSettings = this.buildSignSettingsObject();

        // remove unnessesary fields in inner objects - start
        if (that.model.get('createdBy')) {
            delete that.model.get('createdBy')["object"];
            delete that.model.get('createdBy')["permissions"];
            delete that.model.get('createdBy')["relations"];
        }
        (that.model.get('relations') || []).forEach(function(item) {
            var child = item.child;
            delete child["object"];
            delete child["permissions"];
            delete child["relations"];
        });
        // remove unnessesary fields in inner objects - end

        that.model.save(that.model.toJSON(), {
            success: function() {
                that.ui.saveBtn.attr("disabled", "true");
            },
            error: function(model, xhr, options) {
                notificationsChannel.request('show:notification', xhr.responseText);
            }
        });
    },

    disablePagesToSignElement: function (event) {
        if (event.target.checked) {
            this.ui.pagesToSign.attr('disabled', 'disabled');
            this.signSettings.signAllPages  = true;
            //this.model.get('object').signSettings.signAllPages = true;
        }
        else {
            this.ui.pagesToSign.removeAttr('disabled');
            this.signSettings.signAllPages  = false;
            //this.model.get('object').signSettings.signAllPages = false;
        }
    },

    onKeyPress: function (event) {
        return event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 37 || event.keyCode == 39 ||
            event.charCode >= 48 && event.charCode <= 57;
    },

    entitySelected: function(data) {
        this.findModel(data.id);
        this.onInputChange();
    },

    findModel: function(id) {
        var selectedDocumentType = this.docTypesCollection.findWhere({id: id});
        if (selectedDocumentType != null) {
            this.fillForm(selectedDocumentType.get('object'));
        } else {
            this.fillForm(this.documentTypeModelDefault.get('object'));
        }
    },

    fillForm: function(signSettings) {
        this.ui.signsLimit.val(signSettings.signsLimit);
        this.ui.signX.val(signSettings.signX);
        this.ui.signY.val(signSettings.signY);
        this.ui.signWidth.val(signSettings.signWidth);
    }

});

module.exports = DocumentSignData;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/document-sign-data.js
// module id = 399
// module chunks = 0